import { render, staticRenderFns } from "./CreaPrestazione.vue?vue&type=template&id=3d27fe45&scoped=true&"
import script from "./CreaPrestazione.vue?vue&type=script&lang=js&"
export * from "./CreaPrestazione.vue?vue&type=script&lang=js&"
import style0 from "./CreaPrestazione.vue?vue&type=style&index=0&id=3d27fe45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d27fe45",
  null
  
)

export default component.exports